import { pushSnowplow, toTeamsFeatureSchema } from '../snowplow'
import { ACTION_TARGET_TYPES, ACTION_TYPES, VIEWS, VIEW_TYPES } from './teamsEvents'

export const publishViewedPanelTeams = teamName =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.PANEL_TEAMS,
      VIEW_TYPES.COMPONENT,
      ACTION_TYPES.VIEWED,
      undefined,
      undefined,
      teamName,
    ),
  )

export const publishClickedButtonInPanelTeams = actionTarget =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.PANEL_TEAMS,
      VIEW_TYPES.COMPONENT,
      ACTION_TYPES.CLICKED,
      actionTarget,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishViewedConfirmLeave = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.CONFIRM_LEAVE, VIEW_TYPES.DIALOG, ACTION_TYPES.VIEWED))

export const publishClickedButtonInConfirmLeave = (actionTarget, failureReason) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.CONFIRM_LEAVE,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      actionTarget,
      ACTION_TARGET_TYPES.BUTTON,
      undefined,
      failureReason,
    ),
  )
